// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"232f4bbd","122":"345b184a","161":"dc3e855f","233":"43d2691f","278":"4b2c7c65","322":"2b757fff","782":"2b7a6096","787":"9e9f4ffd","843":"700f7630","856":"935a4226"}[chunkId] + ".chunk.js";
};